import { InputLabel, Space } from '@procurify/ui'

import { PriceFormField } from '@webapp/components/PriceField'
import { CurrencySelect } from '@webapp/core/components/CurrencySelect'
import {
  type Currency,
  type CurrencyName,
} from '@webapp/core/entities/external/Currency'
import { useProcurifyIntl } from '@webapp/hooks'
import { TaxFields } from './TaxFields'
import messages from '../messages'

interface DefaultFieldsProps {
  currencyName: CurrencyName
  selectedCurrency: Currency | null
  onCurrencyChange: (currency: Currency | null) => void
  taxTypeOptions: { label: string; value: string }[]
  isSubmitting: boolean
}

export const DefaultFields = ({
  currencyName,
  selectedCurrency,
  onCurrencyChange,
  taxTypeOptions,
  isSubmitting,
}: DefaultFieldsProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space>
      <Space align='center' justify='end' direction='horizontal'>
        <Space.Item>
          <InputLabel htmlFor='subtotal'>
            {intl.formatMessage(messages.subtotalLabel)}
          </InputLabel>
        </Space.Item>
        <Space.Item width={1 / 3}>
          <PriceFormField
            id='subtotal'
            name='subtotal'
            disabled={isSubmitting}
            inputProps={{ style: { textAlign: 'right' } }}
          />
        </Space.Item>
        <Space.Item width={1 / 3}>
          <CurrencySelect
            inputId='defaultFields-currency-select'
            value={selectedCurrency}
            onChange={onCurrencyChange}
            isDisabled={isSubmitting}
            menuPortalTarget={document.body}
          />
        </Space.Item>
      </Space>

      <TaxFields taxTypeOptions={taxTypeOptions} isSubmitting={isSubmitting} />

      <Space align='center' direction='horizontal' justify='end'>
        <Space.Item>
          <InputLabel>{intl.formatMessage(messages.totalCostLabel)}</InputLabel>
        </Space.Item>
        <Space.Item width={1 / 3}>
          <PriceFormField
            id='totalCost'
            name='totalCost'
            disabled={isSubmitting}
            inputProps={{ style: { textAlign: 'right' } }}
          />
        </Space.Item>
        <Space.Item width={1 / 3}>{currencyName}</Space.Item>
      </Space>
    </Space>
  )
}
